import { Injectable } from '@angular/core';
import { RouteCardItemDto } from './RouteCardItemDto';
import { RouteGroupDto } from './RouteGroupDto';

@Injectable()
export class RouteGroupCreateDto {

    public routeGroup: RouteCardItemDto | null = null;
    public routesGroup: number[] | null = null;

    public static build(rg: RouteGroupDto): RouteGroupCreateDto {
        let result: RouteGroupCreateDto = new RouteGroupCreateDto();

        result.routeGroup = rg.routeGroup;
        result.routesGroup = [];
        if (rg.routesGroup != null)
            rg.routesGroup.forEach(d => {
                result.routesGroup?.push(d.routeId)
            });

        return result;
    }
}
